// @ts-nocheck

import { request } from '../../context';
import type { ApiOptions } from '../../context';
import type {
    PostAiModelInsightTaskBody,
    BaseResponseVoid,
    GetAiModelInsightTaskListQuery,
    BaseResponseListAiModelInsightTask,
} from '../../types';

/**
 * 触发大模型洞察
 *
 * @export
 * @tags ai-model-insight-controller
 * @link [POST] /aiModelInsight/task
 */
export function postAiModelInsightTask(
    data: PostAiModelInsightTaskBody
): Promise<BaseResponseVoid>;
export function postAiModelInsightTask(
    data: PostAiModelInsightTaskBody,
    options: ApiOptions<never, never>
): Promise<BaseResponseVoid>;
export function postAiModelInsightTask(
    data: PostAiModelInsightTaskBody,
    options?: ApiOptions<never, never>
): Promise<BaseResponseVoid> {
    return request<PostAiModelInsightTaskBody, never, never>('/aiModelInsight/task', {
        ...options,
        data,
        method: 'post',
        __$requestCalleeName: 'postAiModelInsightTask',
    });
}
/**
 * 查询任务列表
 *
 * @export
 * @tags ai-model-insight-controller
 * @link [GET] /aiModelInsight/task/list
 */
export function getAiModelInsightTaskList(
    options: ApiOptions<never, GetAiModelInsightTaskListQuery> & {
        params: GetAiModelInsightTaskListQuery;
    }
): Promise<BaseResponseListAiModelInsightTask>{
    return request<never, never, GetAiModelInsightTaskListQuery>('/aiModelInsight/task/list', {
        ...options,
        method: 'get',
        __$requestCalleeName: 'getAiModelInsightTaskList',
    });
}

export const meta = [
    { tags: ['ai-model-insight-controller'], path: '/aiModelInsight/task', method: 'post' },
    { tags: ['ai-model-insight-controller'], path: '/aiModelInsight/task/list', method: 'get' },
];
